import { SVGProps } from 'react';

const CornerDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m15 20 5-5-5-5m5 5H8a4 4 0 0 1-4-4V4"
    />
  </svg>
);
export default CornerDownRight;
